import { useState, useEffect} from 'react';
import { get_po_categories } from '../../api/purchase_orders';
import logger from "../../utils/logger";

const EditPONumberModal = ({ show, onClose, poData, onSave, theme }) => {
    const [comment, setComment] = useState('');
    const [supplier, setSupplier] = useState('');
    const [cost, setCost] = useState('');
    const [category, setCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState('');
    const isLightTheme = theme === 'light';

    logger.log('Current PO Data:', poData);

    const fetchCategories = async () => {
        try {
            const { data, status } = await get_po_categories();
            if (status === 200 && data.success) {
                const sortedCategories = data.categories.sort((a, b) => a.name.localeCompare(b.name));
                setCategories(sortedCategories);
            }
        } catch (error) {
            logger.error('Error fetching categories:', error);
        }
    };

    // on mount load states
    useEffect(() => {
        setComment(poData?.comment || '');
        setSupplier(poData?.supplier || '');
        setCategory(poData?.category || '');
        setCost((poData?.cost !== undefined && poData?.cost !== null && poData?.cost !== '') ? poData.cost : '');
        fetchCategories();
    }, [poData]);

    const handleSave = () => {
        // validate cost (0.00)
        const costPattern = /^\d+\.\d{2}$/;

        if (cost && !costPattern.test(cost)) {
            setError('Cost must be in format 0.00 (exactly 2 decimal places)');
            return;
        }
        setError('');
        onSave({ ...poData, supplier: supplier, comment: comment, cost: cost, category: category });
    };

    if (!show) return null;

    return (
        <div className="modal-overlay" style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0,0,0,0.4)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{
                background: isLightTheme ? '#fff' : '#222',
                color: isLightTheme ? '#222' : '#fff',
                borderRadius: 10,
                padding: 30,
                minWidth: 350,
                boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
                minHeight: 320
            }}>
                <h3 style={{ marginBottom: 20 }}>Edit Purchase Order</h3>
                <div style={{ flex: 1 }}>
                    {!poData ? (
                        <div style={{
                            color: '#888',
                            background: isLightTheme ? '#f5f5f5' : '#333',
                            padding: '30px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            fontSize: '16px',
                            fontWeight: 500
                        }}>
                            No purchase order selected.<br />
                            Please select a PO to edit.
                        </div>
                    ) : (
                        <>
                            <div style={{ marginBottom: 15 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 5, display: 'block' }}>PO Number</label>
                                <input
                                    type="text"
                                    value={poData.po_number || poData.po || ''}
                                    onChange={null}
                                    disabled={true}
                                    style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc', background: isLightTheme ? '#fff' : '#333', color: isLightTheme ? '#636363ff' : '#9e9e9eff' }}
                                />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 5, display: 'block' }}>Supplier</label>
                                <textarea
                                    value={supplier}
                                    onChange={e => setSupplier(e.target.value)}
                                    rows={2}
                                    style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc', background: isLightTheme ? '#fff' : '#333', color: isLightTheme ? '#222' : '#fff' }}
                                />
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 5, display: 'block' }}>Category</label>
                                <select
                                    value={category}
                                    onChange={e => setCategory(e.target.value)}
                                    style={{ 
                                        width: '100%', 
                                        padding: 8, 
                                        borderRadius: 4, 
                                        border: '1px solid #ccc', 
                                        background: isLightTheme ? '#fff' : '#333', 
                                        color: isLightTheme ? '#222' : '#fff' 
                                    }}
                                >
                                    <option value="">Select a category...</option>
                                    {categories.map((cat) => (
                                        <option key={cat.id} value={cat.name}>
                                            {cat.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ marginBottom: 15 }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 5, display: 'block' }}>Comment</label>
                                <textarea
                                    value={comment}
                                    onChange={e => setComment(e.target.value)}
                                    rows={3}
                                    style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc', background: isLightTheme ? '#fff' : '#333', color: isLightTheme ? '#222' : '#fff' }}
                                />
                            </div>
                            <div style={{ marginBottom: 15, position: 'relative' }}>
                                <label style={{ fontWeight: 'bold', marginBottom: 5, display: 'block' }}>Cost £</label>
                                <input
                                    type="text"
                                    value={cost === '' ? '' : cost}
                                    onChange={e => setCost(e.target.value)}
                                    placeholder="0.00"
                                    style={{
                                        width: '100%',
                                        padding: 8,
                                        borderRadius: 4,
                                        border: '1px solid #ccc',
                                        background: isLightTheme ? '#fff' : '#333',
                                        color: cost === '' ? '#888' : (isLightTheme ? '#222' : '#fff')
                                    }}
                                />

                            </div>
                            {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
                        </>
                    )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
                    <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: 4, border: 'none', background: '#888', color: '#fff', cursor: 'pointer' }}>Cancel</button>
                    <button onClick={handleSave} style={{ padding: '8px 16px', borderRadius: 4, border: 'none', background: '#007bff', color: '#fff', cursor: 'pointer' }}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default EditPONumberModal;
